module.exports = __webpack_public_path__ + "files/d79d1d4adac95b7baa36f9b67142e11e.png";